import React from 'react';

import reducer from './reducer';

const initializeFilters = (filters) => {
    let analyzedFilters = Object.keys(filters).map((key) => [key, []]);

    let initialFilters = Object.fromEntries(analyzedFilters);

    return initialFilters;
};

const useFilters = (filters, previouslySelectedFilters, handleFilters = () => null) => {
    const [selectedFilters, dispatch] = React.useReducer(
        reducer,
        previouslySelectedFilters ? previouslySelectedFilters : initializeFilters(filters)
    );
    const [isInitialized, setIsInitialized] = React.useState(false);

    const init = () => setIsInitialized(true);

    const updateSelections = (newSelection, key) => {
        let newState = {};
        newState[key] = newSelection;

        handleFilters(newState, 'filter');

        dispatch({ type: 'update', newState });
    };

    const clearAllSelections = () => {
        let clearedSelectionsObject = initializeFilters(selectedFilters);

        handleFilters(clearedSelectionsObject, 'filter');

        dispatch({ type: 'update', newState: clearedSelectionsObject });
    };

    return { selectedFilters, isInitialized, init, updateSelections, clearAllSelections };
};

export default useFilters;
